<div class="layoutBlock">
	<div class="columnThreeQuarter">
		
		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldSetContainer></ng-template>

        <!-- show patent data for in edit mode -->
        <res-classifications-tab *ngIf="!patent.priorityPatent"
        	[(subjectAreas)]="patent.subjectAreas"
            [(researchAreas)]="patent.researchAreas"
            [(researchAreasKdsf)]="patent.researchAreasKdsf"
        	[dynamicComponent]="patent._dynamicComponent"
            [hisDynamicContent]="'fs.res.common.classifications'" 
        	(subjectAreasChange)="selectedSubjectAreasChange($event)"
        	(researchAreasChange)="selectedResearchAreasChange($event)"
        	subjectAreaDdKey="fs.res.patent.PriorityPatent.subjectAreas"
            researchAreaDdKey="fs.res.patent.PriorityPatent.researchAreas"
            researchAreaKdsfDdKey="fs.res.patent.Patent.researchAreasKdsf">
        </res-classifications-tab>

        <!-- show patent data for in view mode -->
        <div *ngIf="patent.priorityPatent">
    		<p-panel header="{{ 'fs.res.finance.project.search.Project.groupClassification' | hisUi }}">
    
    			<his-plam>
    				<ng-container #content hisDdKey="value.SubjectAreaValue">
    					<p-dataView *ngIf="patent.priorityPatent.subjectAreas && patent.priorityPatent.subjectAreas.length > 0"
    								[value]="patent.priorityPatent.subjectAreas" styleClass="selectedDataContainer"
    								[emptyMessage]="'&nbsp;'">
    					    <ng-template let-selectedSubjectArea let-index="rowIndex" pTemplate="listItem">
    							<div class="selectedDataRow">
    								{{selectedSubjectArea.text}}
    							</div>
    					    </ng-template>
    					</p-dataView>
    				</ng-container>
    			</his-plam>
    
                <his-plam>
                    <ng-container #content hisDdKey="value.ResearchAreaKdsfValue">
                        <p-dataView *ngIf="patent.priorityPatent.researchAreasKdsf && patent.priorityPatent.researchAreasKdsf.length > 0"
                                    [value]="patent.priorityPatent.researchAreasKdsf" styleClass="selectedDataContainer"
                                    [emptyMessage]="'&nbsp;'">
                            <ng-template let-selectedResearchAreaKdsf let-index="rowIndex" pTemplate="listItem">
                                <div class="selectedDataRow">
                                    {{selectedResearchAreaKdsf.text}}
                                </div>
                           </ng-template>
                        </p-dataView>
                    </ng-container>
                </his-plam>
    
                <his-plam hisDdKey="value.ResearchAreaValue">
                    <ng-container #content hisDdKey="value.ResearchAreaValue">
                        <p-dataView *ngIf="patent.priorityPatent.researchAreas && patent.priorityPatent.researchAreas.length > 0"
                                    [value]="patent.priorityPatent.researchAreas" styleClass="selectedDataContainer"
                                    [emptyMessage]="'&nbsp;'">
                            <ng-template let-selectedResearchArea let-index="rowIndex" pTemplate="listItem">
                                <div class="selectedDataRow">
                                    {{selectedResearchArea.text}}
                                </div>
                           </ng-template>
                        </p-dataView>
                    </ng-container>
                </his-plam>
    		</p-panel>
        </div>

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldSetContainer></ng-template>
		
	</div>
</div>
